// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import arrowUpRightIcon from "@/assets/icons/arrow-up-right.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ArrowUpRightIconProps = Omit<IconProps, "name">;

export function ArrowUpRightIcon(props: ArrowUpRightIconProps): React.ReactNode {
  return <Icon name={arrowUpRightIcon} {...props} />;
}
